/**
 * reviews.js — khối đánh giá trang sản phẩm (mục 19), bản demo không có server:
 *   · Chip lọc (Tất cả / Có hình ảnh / 5 sao): một chip bật một lúc, aria-pressed là nguồn
 *     sự thật cho CSS. Bấm lại chip đang bật thì tắt và quay về "Tất cả".
 *   · Nút "Hữu ích?": bấm +1 và chuyển sang trạng thái đã bấm (icon ngón cái đổi sang bản Fill), bấm lại
 *     để rút phiếu — tránh một người bấm cộng mãi.
 *   · "Viết đánh giá": mở hộp thoại chọn sao + nhận xét; gửi thì báo toast cảm ơn.
 *
 * Markup: [data-reviews] > button[data-review-filter="all|photo|<số sao>"]
 *         + [data-review-list] > li[data-rating][data-has-photo?]
 *         + button[data-review-helpful] > [data-review-helpful-count]
 *         + button[data-review-open]  ·  [data-review-modal] > form[data-review-form]
 *
 * Hộp thoại mở bằng .is-open do file này tự quản (khoá cuộn nền, focus vào ô sao, giữ
 * focus trong hộp, Esc / nền tối / nút × để đóng, trả focus về nút "Viết đánh giá").
 * Không mở bằng #hash qua js/modal.js: :target vẫn khớp sau history.replaceState
 * nên modal mở bằng hash không đóng được.
 *
 * WP: lọc là query var (?rating=5) xử lý ở PHP, "Hữu ích" là comment meta + admin-ajax,
 * form là comment_form() gửi wp-comments-post.php (WooCommerce giữ chờ duyệt).
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var root = document.querySelector('[data-reviews]');
    if (!root) return;

    var MIN_COMMENT = 10;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

    // ----- Lọc -----
    var chips = [].slice.call(root.querySelectorAll('[data-review-filter]'));
    var empty = root.querySelector('[data-review-empty]');

    function matches(item, filter) {
        if (filter === 'photo') return item.hasAttribute('data-has-photo');
        if (/^[1-5]$/.test(filter)) return item.getAttribute('data-rating') === filter;
        return true;
    }

    function applyFilter(filter) {
        var shown = 0;
        [].slice.call(root.querySelectorAll('[data-review-list] > li')).forEach(function (item) {
            var ok = matches(item, filter);
            item.hidden = !ok;
            if (ok) shown += 1;
        });
        if (empty) empty.hidden = shown > 0;
    }

    function selectChip(chip) {
        chips.forEach(function (other) {
            other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
        });
        applyFilter(chip.getAttribute('data-review-filter'));
    }

    chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
            var all = chips.filter(function (c) {
                return c.getAttribute('data-review-filter') === 'all';
            })[0];
            var isOn = chip.getAttribute('aria-pressed') === 'true';
            selectChip(isOn && all && chip !== all ? all : chip);
        });
    });

    // ----- Hữu ích -----
    root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-review-helpful]');
        if (!button) return;
        var counter = button.querySelector('[data-review-helpful-count]');
        var voted = button.getAttribute('aria-pressed') === 'true';
        var count = (parseInt(counter && counter.textContent, 10) || 0) + (voted ? -1 : 1);

        if (counter) counter.textContent = String(Math.max(0, count));
        button.setAttribute('aria-pressed', voted ? 'false' : 'true');
        var icon = button.querySelector('i');
        if (icon) icon.className = (voted ? 'ph-bold' : 'ph-fill') + ' ph-thumbs-up';
    });

    // ----- Hộp thoại viết đánh giá -----
    var modal = document.querySelector('[data-review-modal]');
    var opener = root.querySelector('[data-review-open]');
    var form = modal ? modal.querySelector('[data-review-form]') : null;
    if (!modal || !opener || !form) return;

    var panel = modal.querySelector('.modal__panel');
    var hint = form.querySelector('[data-star-hint]');
    var hintDefault = hint ? hint.textContent : '';
    var lastFocus = null;

    function isOpen() {
        return modal.classList.contains('is-open');
    }

    function open() {
        lastFocus = document.activeElement;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        // .modal chuyển visibility bằng transition: ở khung hình đầu nó vẫn là hidden và
        // focus() bị bỏ qua — chờ 50ms (đã sang giữa transition, visibility là visible)
        window.setTimeout(function () {
            var star = form.querySelector('input[name="rating"]:checked') || form.querySelector('input[name="rating"]');
            if (star) star.focus();
        }, 50);
    }

    function close() {
        if (!isOpen()) return;
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        lastFocus = null;
    }

    function setError(name, show) {
        var message = form.querySelector('[data-review-error="' + name + '"]');
        if (message) message.hidden = !show;
        var field = message ? message.closest('.field, .star-input') : null;
        if (field) field.classList.toggle('field--error', show);
        var control = name === 'comment' ? form.querySelector('[name="comment"]') : null;
        if (!control) return;
        control.setAttribute('aria-invalid', show ? 'true' : 'false');
        // Đọc thông báo lỗi thay cho dòng gợi ý khi đang lỗi (gợi ý bị ẩn bằng CSS lúc đó)
        if (!control.hasAttribute('data-help')) control.setAttribute('data-help', control.getAttribute('aria-describedby') || '');
        control.setAttribute('aria-describedby', show && message.id ? message.id : control.getAttribute('data-help'));
    }

    function resetForm() {
        form.reset();
        setError('rating', false);
        setError('comment', false);
        if (hint) hint.textContent = hintDefault;
    }

    opener.addEventListener('click', open);

    modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-review-close]')) close();
    });

    // Nhãn của sao đang chọn ("Tuyệt vời"…) hiện cạnh hàng sao cho người nhìn
    form.addEventListener('change', function (event) {
        if (event.target.name !== 'rating') return;
        setError('rating', false);
        var label = form.querySelector('label[for="' + event.target.id + '"] .screen-reader-text');
        if (hint && label) hint.textContent = label.textContent.split('—').pop().trim();
    });

    form.addEventListener('input', function (event) {
        if (event.target.name === 'comment' && event.target.value.trim().length >= MIN_COMMENT) {
            setError('comment', false);
        }
    });

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        var rating = form.querySelector('input[name="rating"]:checked');
        var comment = form.querySelector('[name="comment"]');
        var ratingBad = !rating;
        var commentBad = !comment || comment.value.trim().length < MIN_COMMENT;

        setError('rating', ratingBad);
        setError('comment', commentBad);

        if (ratingBad) {
            form.querySelector('input[name="rating"]').focus();
            return;
        }
        if (commentBad) {
            comment.focus();
            return;
        }

        close();
        resetForm();
        if (window.WBToast) {
            window.WBToast.show('Cảm ơn bạn! Đánh giá sẽ hiển thị sau khi được duyệt.', {
                icon: 'ph-fill ph-check-circle'
            });
        }
    });

    document.addEventListener('keydown', function (event) {
        if (!isOpen()) return;

        if (event.key === 'Escape' || event.key === 'Esc') {
            close();
            return;
        }

        if (event.key !== 'Tab' || !panel) return;

        // Giữ focus trong hộp thoại; nhóm radio sao chỉ tính ô đang được Tab tới
        var items = [].slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
            if (el.type === 'radio' && !el.checked) {
                var group = form.querySelector('input[name="' + el.name + '"]:checked');
                if (group || el !== form.querySelector('input[name="' + el.name + '"]')) return false;
            }
            return el.offsetWidth > 0 || el.offsetHeight > 0 || el.type === 'radio';
        });
        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });
})();
